import * as z from 'zod';
import { DEFAULT_PAGE_SIZE, FIRST_PAGE } from '@noor/config';

export const BUSINESS_STATUS_FILTERS = ['all', 'active', 'inactive'] as const;
export type BusinessStatusFilter = (typeof BUSINESS_STATUS_FILTERS)[number];

export const businessListSearchSchema = z.object({
  search: z.string().optional(),
  status: z.enum(BUSINESS_STATUS_FILTERS).optional(),
  page: z.coerce.number().int().positive().default(FIRST_PAGE),
  pageSize: z.coerce.number().int().positive().default(DEFAULT_PAGE_SIZE),
});
export const bannerTypeSearchSchema = z
  .enum(['restaurant', 'product'])
  .default('restaurant');
export type BannerType = z.infer<typeof bannerTypeSearchSchema>;
export type BusinessListSearch = z.infer<typeof businessListSearchSchema>;

export interface BusinessListFilter {
  limit: number;
  offset: number;
}

/**
 * Search and status have no server-side counterpart on these admin lists, so
 * while either is set the table filters the whole collection client-side.
 */
export function isBusinessFilterActive(
  search: Pick<BusinessListSearch, 'search' | 'status'>,
): boolean {
  return !!search.search?.trim() || (!!search.status && search.status !== 'all');
}

export function businessSearchToFilter(search: BusinessListSearch): BusinessListFilter {
  return {
    limit: search.pageSize,
    offset: (search.page - 1) * search.pageSize,
  };
}
